
<template>
  <layout :drawer="false">

    <template slot="nav-tools">
      <smart-btn @click.native="onNewWorkshop" class="mr-1">
        <v-icon>mdi-card-plus-outline</v-icon>
        <span class="pl-1">Nouveau workshop</span>
      </smart-btn>
    </template>

   <template slot="content">
      <v-container fluid>
        <v-card fluid>
          <v-card-title>
            <h3>Workshops</h3>
          </v-card-title>

          <v-data-table
              :headers="headers"
              :items="workshops"
              :sort-by="['status', 'startDate']"
              :sort-desc="[false, true]"
              :disable-pagination="true"
              :hide-default-footer="true"
              class="elevation-1 tbl"
              no-data-text="Aucun workshop enregistré."
              @click:row="openWorkshopDetail"
          >
            <template #header.userId="{ header }">
              <span class="pl-6">
                {{ header.text }}
              </span>
            </template>
            <template #item.userId="{ item }">
              <span class="pl-6">{{ item | fullname(true) }}</span>
            </template>
            <template #item.cost="{ item }">
              {{ _formatCurrency(item.cost, "EUR") }}
            </template>
            <template #item.status="{ item }">
                <StatusChip small :value="item.status" />
            </template>
            <template #item.startDate="{ value }">
              <div v-if="value" class="d-flex items-center">
                <span class="mr-2">{{ _convertDay(value) }}</span>
                <span class="caption grey--text">{{ _convertHour(value) }}</span>
              </div>
            </template>
            <template #item.stopDate="{ value }">
              <div v-if="value" class="d-flex items-center">
                <span class="mr-2">{{ _convertDay(value) }}</span>
                <span class="caption grey--text">{{ _convertHour(value) }}</span>
              </div>
            </template>
            <template #item.actions="{item}">
              <v-row no-gutters justify="end" class="pr-6">
                <v-icon small class="mr-2" @click.stop="edit(item)">edit</v-icon>
                <v-icon small class="" @click.stop="onDelete(item)">delete</v-icon>
              </v-row>
            </template>

          </v-data-table>

        </v-card>

        <!-- EDIT-CREATE-DELETE WORKSHOP DIALOG -->
        <WorkshopEditDialog
            v-if="edition.dialog"
            v-model="edition.dialog"
            :workshop="edition.workshop"
            :context="edition.context"
            @saved="init"
            @created="openWorkshopDetail"
            @deleted="init"
        />
      </v-container>
    </template>

  </layout>
</template>



<script>
import Layout from "@/views/Layout.vue";
import {get} from "@/utils/api";
import FormMixin from "@/components/mixins/FormMixin";
import StatusChip from "@/components/commons/StatusChip.vue";
import WorkshopEditDialog from "@/views/hlagons/workshop/WorkshopEditDialog.vue";

export default {
  name: "WorkshopList",
  mixins: [FormMixin],
  components: {WorkshopEditDialog, StatusChip, Layout },
  data: () => ({
    fetchData: {
      loading: false,
      noFetchYet: true,
    },
    headers: [
      { text:"UTILISATEUR", value:"userId"},
      { text:"NOM OU LIEU", value:"place"},
      { text: "DATE DU WORKSHOP", value: "startDate", align: "left", sortable: true,
        sort: (a, b) => new Date(a) - new Date(b) },
      { text: "DATE DE CLÔTURE", value: "stopDate", align: "left", sortable: true,
        sort: (a, b) => new Date(a) - new Date(b) },
      { text:"COÛT", value:"cost", align: "center"},
      { text:"SESSIONS", value:"meetCount", align: "center"},
      { text:"PARTICIPANTS", value:"contactCount", align: "center"},
      { text:"STATUS", value:"status", sortable: true,
        sort: (a, b) => {
          const order = { not_started: 0, in_progress: 1, closed: 2 }
          return (order[a] ?? 999) - (order[b] ?? 999)
        }
      },
      { text: "ACTIONS", value: "actions", align: "right" },
    ],
    workshops: [],
    edition: {
      dialog: false,
      workshop: null,
      context: "CREATE"
    },
  }),
  created() {
    this.init();
  },
  watch: {},
  computed: {},
  methods: {
    init() {
      this.fetchData.loading = true
      const url = "/api/workshop";

      get(url).json((r) => {
        this.workshops = r;
        this.fetchData.noFetchYet = false
        this.fetchData.loading = false
      });
    },
    emptyWorkshop() {
      return {
        id: null,
        place: "",
        userId: -1,
        status: "not_started",
        comment: null,
        cost: null,
        startDate: this._formatDate(new Date(), "yyyy-MM-dd"),
        stopDate : null,
      }
    },
    onNewWorkshop() {
      this.edition.workshop = this.emptyWorkshop()
      this.edition.context = "CREATE"
      this.edition.dialog = true
    },
    edit(workshop) {
      this.edition.workshop = { ...workshop }
      this.edition.context = "EDIT"
      this.edition.dialog = true
    },
    onDelete(workshop) {
      this.edition.workshop = { ...workshop }
      this.edition.context = "DELETE"
      this.edition.dialog = true
    },
    openWorkshopDetail(workshop) {
      if(!workshop) {
        this.init()
        return
      }
      this.$router.push({
        name: "WorkshopDetails",
        params: {workshopId: String(workshop.id)},
      });
    },
    getUsername(workshop) {
      if (!workshop.firstname && !workshop.lastname) {
        return `Utilisateur ${workshop.userId}`
      }
      return `${workshop.firstname} ${workshop.lastname.slice(0, 1)}.`
    },
  }

}
</script>

<style scoped>

</style>